module.exports = __webpack_public_path__ + "img/carshina21_16.58e5d81c.jpg";